import { Model } from 'modules/core/lib/mobx-rest'

import jobLevelSalaryRangesCollection from 'modules/job_catalog/store/collections/salaryRanges'
import type JobLevelSalaryRange from 'modules/job_catalog/store/models/JobLevelSalaryRange'

export interface Attributes {
  id: number
  role_id: number
  name: string
  order: number
  archived: boolean
  is_default: boolean
}

class JobLevel extends Model<Attributes> {
  static urlRoot() {
    return '/job_catalog/levels'
  }

  get salaryRanges(): JobLevelSalaryRange[] {
    return jobLevelSalaryRangesCollection.filter({ level_id: this.attributes.id })
  }

  get isArchived(): boolean {
    return this.attributes.archived
  }

  get isActive(): boolean {
    return !this.attributes.archived
  }

  get isDefault(): boolean {
    return this.attributes.is_default
  }
}

export default JobLevel
